import { classes } from '@theme/constants';
import { HTMLCustomElement } from '@theme/html-custom-element';

class PrivateHireForm extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('submit', this.refs.form, async (event) => {
      event.preventDefault();

      this.refs.submit.disabled = true;

      const { ok } = await fetch(event.target.action, {
        method: event.target.method.toUpperCase(),
        body: new FormData(event.target),
      });

      if (ok) {
        this.refs.form.reset();
      }

      this.refs.form.classList.toggle(classes.success, ok);
      this.refs.form.classList.toggle(classes.error, !ok);

      this.refs.submit.disabled = false;
    });
  }
}

if (!customElements.get('private-hire-form')) customElements.define('private-hire-form', PrivateHireForm);
